<template>
  <div class="messengers-admin">
    <div class="messengers-admin__toolbar">
      <el-input
        v-model="search"
        placeholder="Поиск по аккаунту, домену, каналу"
        clearable
        @input="debouncedSearch"
      />
    </div>

    <el-table :data="accounts" style="width: 100%" row-key="installation_id">
      <el-table-column type="expand">
        <template #default="scope">
          <div class="messengers-admin__channels">
            <div v-if="scope.row.channels.length === 0" class="messengers-admin__empty">
              Каналы не найдены
            </div>
            <div v-for="channel in scope.row.channels" :key="channel.id" class="messengers-admin__channel-card">
              <div class="messengers-admin__channel-top">
                <div class="messengers-admin__channel-title">{{ channel.title || channel.type }}</div>
                <el-tag :type="tagType(channel.status)" effect="light">{{ channel.status }}</el-tag>
              </div>
              <div class="messengers-admin__channel-meta">
                <div><b>Тип:</b> {{ channel.type }}</div>
                <div><b>External ID:</b> {{ channel.external_id }}</div>
                <div><b>Profile:</b> {{ channel.profile_external_id || 'main' }}</div>
                <div><b>Телефон:</b> {{ channel.profile_phone || channel.settings?.phone || '—' }}</div>
                <div><b>Обновлен:</b> {{ formatDate(channel.updated_at) }}</div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Account ID" prop="account_id" width="130" />
      <el-table-column label="Домен" prop="subdomain" min-width="160" />
      <el-table-column label="Название" prop="title" min-width="180" />
      <el-table-column label="Каналов" width="110">
        <template #default="scope">
          {{ scope.row.channels.length }}
        </template>
      </el-table-column>
      <el-table-column label="Активных" width="110">
        <template #default="scope">
          {{ scope.row.channels.filter((item) => item.status === 'active').length }}
        </template>
      </el-table-column>
      <el-table-column label="Обновлен" width="130">
        <template #default="scope">
          {{ formatDate(scope.row.updated_at) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from 'moment';
import store from "@/components/store/store";

let searchTimer = null;

export default {
  name: 'MessengerAccounts',
  data() {
    return {
      search: ''
    };
  },
  computed: {
    accounts() {
      return store.state.messengerAccounts;
    }
  },
  async mounted() {
    await store.dispatch('fetchMessengerAccounts');
  },
  methods: {
    debouncedSearch() {
      if (searchTimer) {
        clearTimeout(searchTimer);
      }
      searchTimer = setTimeout(() => {
        store.dispatch('fetchMessengerAccounts', { search: this.search });
      }, 250);
    },
    formatDate(value) {
      const ts = Number(value || 0);
      if (!ts) {
        return '—';
      }
      return moment(ts * 1000).format('DD.MM.YYYY');
    },
    tagType(status) {
      if (status === 'active') {
        return 'success';
      }
      if (status === 'disabled') {
        return 'danger';
      }
      return 'info';
    }
  }
}
</script>

<style scoped>
.messengers-admin {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.messengers-admin__toolbar {
  display: flex;
  justify-content: flex-start;
}

.messengers-admin__toolbar .el-input {
  max-width: 360px;
}

.messengers-admin__channels {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 12px;
  background: #f8fbff;
  border-radius: 10px;
}

.messengers-admin__channel-card {
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #dce6f2;
  border-radius: 10px;
}

.messengers-admin__channel-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.messengers-admin__channel-title {
  font-size: 15px;
  font-weight: 700;
}

.messengers-admin__channel-meta {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
  text-align: left;
  font-size: 13px;
}

.messengers-admin__empty {
  text-align: left;
  color: #7c8aa5;
}
</style>
